import React, { Component } from 'react';
import './Category.scss';
import Dropdown from './Dropdown/Dropdown';
import Search from '@/Common/Search/Search';
import MainCategoryButton from './MainCategoryButton/MainCategoryButton';
import SubCategoryButton from './SubCategoryButton/SubCategoryButton';

/*



    NOTE :: LAGACY (사용하지 않는 컴포넌트로 추후 삭제 예정)



*/

class Category extends Component {
    render() {
        // const { onCheckboxChanged, categories ,whichMainCateGoryClick,onClickMainCategoryButton,searchBtnClick ,value :lang} = this.props;
        return (
            <></>
            // <div className={`Category-container`}>
            //     <div className="Category-container-header">
            //         <Dropdown onCheckboxChanged={onCheckboxChanged} categories={categories} />
            //         <MainCategoryButton whichMainCateGoryClick={whichMainCateGoryClick} onClick={onClickMainCategoryButton} value={lang}/>
            //         <Search searchBtnClick={searchBtnClick} />
            //     </div>
            //     <div >
            //         <SubCategoryButton categories={categories} whichMainCateGoryClick={whichMainCateGoryClick} onCheckboxChanged={onCheckboxChanged}/>
            //     </div>
            // </div>
        );
    }
}

export default Category;